var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessaging({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.958,
    height: 50,
    viewBox: "0 0 50.958 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messaging",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M33.109,15c10.554,0,19.109,7.7,19.109,17.2a16.237,16.237,0,0,1-5.095,11.664c.005.409,0,4.26,5.095,6.808,0,0-1.274,1.274-4.459,1.274-7.007,0-9.555-3.185-9.555-3.185h0a21.1,21.1,0,0,1-5.1.637C22.556,49.4,14,41.7,14,32.2S22.556,15,33.109,15Z",
    transform: "translate(2.74 2.055)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M21,23H41.383v2.547H21Zm0,6.37H41.383v2.547H21Zm2.548,6.37h12.74v2.548H23.548Z",
    transform: "translate(4.657 4.555)",
    fill: "#bbdefb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M40.593,25.192a18.094,18.094,0,0,0,1.434-7.007c0-.413-.041-.815-.068-1.222A20.737,20.737,0,0,0,33.109,15C22.556,15,14,22.7,14,32.2a15.609,15.609,0,0,0,1.182,5.91,9.951,9.951,0,0,0,.845-.59,23.439,23.439,0,0,0,4.343.413,22.923,22.923,0,0,0,12.766-3.822h-.027V31.562h3.154A20.081,20.081,0,0,0,39.31,27.74h-1.1V25.192Z",
    transform: "translate(2.74 2.531)",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M21,25.547H37.392A18.98,18.98,0,0,0,38.675,23H21Zm0,6.37H31.206a21.385,21.385,0,0,0,3.131-2.547H21Z",
    transform: "translate(4.657 4.653)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2639",
    "data-name": "Group 2639",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M23.109,4C12.556,4,4,11.7,4,21.2A16.237,16.237,0,0,0,9.095,32.863c-.005.409,0,4.26-5.095,6.808,0,0,1.274,1.274,4.459,1.274,7.007,0,9.555-3.185,9.555-3.185h0a21.1,21.1,0,0,0,5.1.637c10.554,0,19.109-7.7,19.109-17.2S33.663,4,23.109,4Z",
    transform: "translate(-4 -4)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M11,12H31.383v2.547H11Zm0,6.369H31.383v2.548H11Zm0,6.37H26.288v2.548H11Z",
    transform: "translate(-2.082 -1.808)",
    fill: "#ffecb3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessaging);
export default __webpack_public_path__ + "static/media/messaging.07102198de7a0c250f85b056c3587535.svg";
export { ForwardRef as ReactComponent };